class FeaturedProductsSlider {
  constructor(containerId) {
    this.container = document.getElementById(containerId);
    if (!this.container) return;
    
    this.slider = this.container.querySelector('.featured-products-slider__grid');
    this.prevButton = this.container.querySelector('.featured-products-slider__scroll-button--prev');
    this.nextButton = this.container.querySelector('.featured-products-slider__scroll-button--next');
    this.categoryLinks = this.container.querySelectorAll('.featured-products-slider__category-link');
    
    if (!this.slider) return;
    
    this.slider.scrollLeft = 0;
    
    this.initializeSlider();
    this.setupEventListeners();
    this.setupCategories();
    
    setTimeout(() => {
      this.slider.scrollLeft = 0;
    }, 100);
  }
  
  initializeSlider() {
    
    this.isDown = false;
    this.isDragging = false;
    this.startX = 0;
    this.scrollLeft = 0;
    this.lastPageX = 0;
    this.maxScroll = 0;
    
    this.slideItems = this.container.querySelectorAll('.featured-products-slider__grid-item');
    if (this.slideItems.length > 0) {
      this.slideWidth = this.slideItems[0].offsetWidth + 
                        parseInt(window.getComputedStyle(this.slideItems[0]).marginRight || 20);
      
      this.maxScroll = this.calculateMaxScroll();
    }
    
    this.slider.setAttribute('data-smooth-scroll', 'true');
  }
  
  calculateMaxScroll() {
    return this.slideItems.length * this.slideWidth - this.slider.clientWidth;
  }
  
  setupEventListeners() {
    this.slider.addEventListener('mousedown', this.onMouseDown.bind(this), { passive: false });
    document.addEventListener('mousemove', this.onMouseMove.bind(this), { passive: false });
    document.addEventListener('mouseup', this.onMouseUp.bind(this));
    this.slider.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    
    // this.slider.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: false });
    // document.addEventListener('touchmove', this.onTouchMove.bind(this), { passive: false });
    // document.addEventListener('touchend', this.onTouchEnd.bind(this));
    
    if (this.prevButton) {
      this.prevButton.addEventListener('click', this.onPrevClick.bind(this));
    }
    
    if (this.nextButton) {
      this.nextButton.addEventListener('click', this.onNextClick.bind(this));
    }
    
    window.addEventListener('resize', this.handleResize.bind(this));
    window.addEventListener('load', () => {
      this.slider.scrollLeft = 0;
      this.updateNavButtonStates();
    });
    
    this.slider.addEventListener('scroll', this.handleScroll.bind(this));
  }
  
  handleScroll() {
    if (!this.isDragging) {
      this.updateNavButtonStates();
    }
  }
  
  updateNavButtonStates() {
    if (this.prevButton) {
      this.prevButton.style.opacity = this.slider.scrollLeft <= 5 ? '0.5' : '1';
    }
    
    if (this.nextButton) {
      this.nextButton.style.opacity = this.slider.scrollLeft >= this.maxScroll - 5 ? '0.5' : '1';
    }
  }
  
  setupCategories() {
    if (this.categoryLinks.length > 0) {
      this.categoryLinks.forEach(link => {
        link.classList.remove('active');
        
        link.addEventListener('click', (e) => {
          if (!link.getAttribute('href') || link.getAttribute('href') === '#') {
            e.preventDefault();
            this.categoryLinks.forEach(l => l.classList.remove('active'));
            link.classList.add('active');
          }
        });
      });
      
      this.categoryLinks[0].classList.add('active');
    }
  }
  
  enableSmoothScroll() {
    this.slider.style.scrollBehavior = 'smooth';
    this.slider.setAttribute('data-smooth-scroll', 'true');
  }
  
  disableSmoothScroll() {
    this.slider.style.scrollBehavior = 'auto';
    this.slider.setAttribute('data-smooth-scroll', 'false');
  }
  
  isSmoothScrollEnabled() {
    return this.slider.getAttribute('data-smooth-scroll') === 'true';
  }
  
  onMouseDown(e) {
    this.isDown = true;
    this.isDragging = false;
    this.slider.classList.add('active');
    
    this.startX = e.pageX;
    this.lastPageX = e.pageX;
    this.scrollLeft = this.slider.scrollLeft;
    
    this.disableSmoothScroll();
    e.preventDefault();
  }
  
  onMouseMove(e) {
    if (!this.isDown) return;
    
    const x = e.pageX;
    const walk = (this.startX - x);
    
    if (Math.abs(walk) > 3) {
      this.isDragging = true;
      
      const newScrollPos = this.scrollLeft + walk;
      if (newScrollPos >= 0 && newScrollPos <= this.maxScroll) {
        this.slider.scrollLeft = newScrollPos;
      }
      
      this.lastPageX = x;
    }
    
    e.preventDefault();
  }
  
  onMouseUp(e) {
    if (!this.isDown) return;
    
    this.isDown = false;
    this.slider.classList.remove('active');
    
    if (this.isDragging) {
      this.snapToNearestSlide();
    }
    
    this.isDragging = false;
  }
  
  onMouseLeave() {
    if (this.isDown) {
      this.isDown = false;
      this.slider.classList.remove('active');
      
      if (this.isDragging) {
        this.snapToNearestSlide();
      }
      
      this.isDragging = false;
    }
  }
  
  onTouchStart(e) {
    this.isDown = true;
    this.isDragging = false;
    this.slider.classList.add('active');
    
    this.startX = e.touches[0].pageX;
    this.lastPageX = e.touches[0].pageX;
    this.scrollLeft = this.slider.scrollLeft;
    
    this.disableSmoothScroll();
    e.preventDefault();
  }
  
  onTouchMove(e) {
    if (!this.isDown) return;
    
    const x = e.touches[0].pageX;
    const walk = (this.startX - x);
    
    if (Math.abs(walk) > 3) {
      this.isDragging = true;
      
      const newScrollPos = this.scrollLeft + walk;
      if (newScrollPos >= 0 && newScrollPos <= this.maxScroll) {
        this.slider.scrollLeft = newScrollPos;
        e.preventDefault();
      }
      
      this.lastPageX = x;
    }
  }
  
  onTouchEnd() {
    if (!this.isDown) return;
    
    this.isDown = false;
    this.slider.classList.remove('active');
    
    if (this.isDragging) {
      this.snapToNearestSlide();
    }
    
    this.isDragging = false;
  }
  
  snapToNearestSlide() {
    const currentPosition = this.slider.scrollLeft;
    const slideIndex = Math.round(currentPosition / this.slideWidth);
    const targetPosition = Math.max(0, Math.min(slideIndex * this.slideWidth, this.maxScroll));
    
    this.smoothScrollTo(targetPosition);
  }
  
  smoothScrollTo(position) {
    this.enableSmoothScroll();
    this.slider.scrollLeft = position;
    
    setTimeout(() => {
      this.disableSmoothScroll();
      this.updateNavButtonStates();
    }, 300);
  }
  
  onPrevClick() {
    const visibleSlides = this.getVisibleSlides();
    const scrollAmount = Math.floor(visibleSlides) * this.slideWidth;
    const targetPosition = Math.max(0, this.slider.scrollLeft - scrollAmount);
    
    this.smoothScrollTo(targetPosition);
  }
  
  onNextClick() {
    const visibleSlides = this.getVisibleSlides();
    const scrollAmount = Math.floor(visibleSlides) * this.slideWidth;
    const targetPosition = Math.min(this.maxScroll, this.slider.scrollLeft + scrollAmount);
    
    this.smoothScrollTo(targetPosition);
  }
  
  getVisibleSlides() {
    const style = getComputedStyle(this.container);
    
    if (window.innerWidth >= 990) {
      return parseFloat(style.getPropertyValue('--desktop-visible-slides') || '4.5');
    } else if (window.innerWidth >= 750) {
      return parseFloat(style.getPropertyValue('--tablet-visible-slides') || '3');
    } else {
      return parseFloat(style.getPropertyValue('--mobile-visible-slides') || '1.5');
    }
  }
  
  handleResize() {
    if (this.slideItems.length > 0) {
      this.slideWidth = this.slideItems[0].offsetWidth + 
                        parseInt(window.getComputedStyle(this.slideItems[0]).marginRight || 20);
      this.maxScroll = this.calculateMaxScroll();
    }
    
    this.updateNavButtonStates();
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const sliderContainers = document.querySelectorAll('[id^="FeaturedSlider-"]');
  
  window.featuredSliders = window.featuredSliders || [];
  sliderContainers.forEach(container => {
    window.featuredSliders.push(new FeaturedProductsSlider(container.id));
  });
});